import { call, put, takeLatest } from 'redux-saga/effects';
import { putSession } from '../../../globals/api/requests';
import trackingActions from '../../../areas/user/actions/tracking';

export function* addCookie({ version, privacySettings, isLoggedIn }) {
  yield call(putSession, 'cookie_consent_version', version);
  if (privacySettings) {
    document.getElementById('root-cookiebanner')?.remove();
    yield put(trackingActions.trackingToggleSave(privacySettings, isLoggedIn));
  }
}

function* mySaga() {
  yield takeLatest('ACCEPT_COOKIES', addCookie);
}

export default mySaga;
